import { ArrowRight, MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/components/site/FloatingCall";

export default function Hero({ onCtaClick }) {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative pt-36 pb-24 lg:pt-44 lg:pb-32 overflow-hidden bg-[#0d3d2e] isolate"
        >
            {/* Background image with overlay */}
            <div className="absolute inset-0 z-0">
                <img
                    src="/images/hero-bg.webp"
                    alt=""
                    className="w-full h-full object-cover opacity-40"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#0d3d2e]/70 via-[#0d3d2e]/85 to-[#0d3d2e]" />
            </div>

            <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 items-end">
                <div className="lg:col-span-8 text-[#fcfbf8] reveal">
                    <h1 className="font-display text-[44px] leading-[1.05] sm:text-6xl lg:text-[76px] lg:leading-[0.98] tracking-tight">
                        Noi comparăm.<br />
                        <em className="not-italic text-[#d4af37]">Tu alegi</em> ce ți se potrivește.
                    </h1>
                    <p className="mt-8 text-lg lg:text-xl text-[#fcfbf8]/80 max-w-2xl">
                        Îți punem la dispoziție toate produsele din piață — asigurări, credite
                        și soluții financiare comparate, într-o singură ofertă clară.
                    </p>

                    <div className="mt-10 flex flex-col sm:flex-row gap-3 flex-wrap">
                        <button
                            onClick={onCtaClick}
                            data-testid="hero-cta-btn"
                            className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#d4af37] text-[#1a1a1a] px-6 py-3.5 text-base font-medium hover:bg-[#e0bd49] transition-all"
                        >
                            Cere ofertă gratuită
                            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" strokeWidth={1.75} />
                        </button>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="hero-whatsapp-btn"
                            className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-white px-6 py-3.5 text-base font-medium hover:bg-[#1ebe57] transition-colors"
                        >
                            <MessageCircle className="h-4 w-4" strokeWidth={2} fill="white" />
                            Scrie-ne pe WhatsApp
                        </a>
                        <a
                            href="tel:0745643348"
                            data-testid="hero-call-btn"
                            className="inline-flex items-center justify-center gap-2 rounded-full border border-[#fcfbf8]/30 text-[#fcfbf8] px-6 py-3.5 text-base font-medium hover:bg-[#fcfbf8]/10 transition-colors"
                        >
                            Sună 0745 643 348
                        </a>
                    </div>
                </div>

                <div className="lg:col-span-4 grid grid-cols-3 lg:grid-cols-1 gap-4 text-[#fcfbf8]">
                    {[
                        { k: "20+", v: "Companii partenere" },
                        { k: "100%", v: "Consultanță gratuită" },
                        { k: "24h", v: "Răspuns la cerere" },
                    ].map((s) => (
                        <div
                            key={s.k}
                            className="border-t border-[#fcfbf8]/20 pt-4"
                            data-testid={`hero-stat-${s.k}`}
                        >
                            <div className="font-display text-4xl lg:text-5xl text-[#d4af37]">{s.k}</div>
                            <div className="text-xs lg:text-sm uppercase tracking-[0.14em] text-[#fcfbf8]/70 mt-1">
                                {s.v}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
